import { createRouter, createWebHistory } from "vue-router";
import redirectIfNotLogged from "@/lib/redirectIfNotLogged.guard";
import CONSTANTS from "@/lib/CONSTANTS";
import ShipmentOverview from "../views/ShipmentOverview.vue";
import OrderSecurePaper from "../views/OrderSecurePaper.vue";
import DuplicateShipments from "../views/DuplicateShipments.vue";
import ETAChanges from "../components/ETAChanges.vue";

/**
 * Creates a route guard that redirects to manage bookings no default overview, default overview override, or default overview is not SO
 * @returns {Function} Route guard function
 */

const router = createRouter({
  history: createWebHistory(CONSTANTS.APP_BASE),
  routes: [
    {
      path: "/",
      redirect: "/export"
    },
    {
      path: "/export",
      name: "export",
      component: ShipmentOverview,
      beforeEnter: (to, from, next) => {
        redirectIfNotLogged(to.path.slice(1), next);
      },
      children: [
        {
          path: ":tab",
          component: ShipmentOverview
        },
        {
          path: "/air",
          name: "air"
        }
      ]
    },
    {
      path: "/export/lcl",
      name: "exportLcl",
      component: ShipmentOverview,
      beforeEnter: (to, from, next) => {
        redirectIfNotLogged(to.path.slice(1), next);
      },
      children: [
        {
          path: ":tab",
          component: ShipmentOverview
        }
      ]
    },
    {
      path: "/import",
      name: "import",
      component: ShipmentOverview,
      beforeEnter: (to, from, next) => {
        redirectIfNotLogged(to.path.slice(1), next);
      },
      children: [
        {
          path: ":tab",
          component: ShipmentOverview
        },
        {
          path: "/lcl",
          name: "lcl"
        },
        {
          path: "/air",
          name: "air"
        }
      ]
    },
    {
      path: "/order-bl-paper",
      name: "order-bl-paper",
      component: OrderSecurePaper,
      beforeEnter: (to, from, next) => {
        redirectIfNotLogged(to.path.slice(1), next);
      }
    },
    {
      path: "/duplicate",
      name: "duplicate",
      component: DuplicateShipments,
      beforeEnter: (to, from, next) => {
        redirectIfNotLogged(to.path.slice(1), next);
      }
    },
    {
      path: "/etachanges",
      name: "etachanges",
      component: ETAChanges,
      beforeEnter: (to, from, next) => {
        redirectIfNotLogged(to.path.slice(1), next);
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0, behaviour: "smooth" };
    }
  }
});

export default router;
